import React from "react";
import { makeStyles } from "@material-ui/styles";
import { useLanguage, LANG } from "../../../contexts/LanguageContext";

const useStyles = makeStyles(() => ({
  toggleContainer: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "8px 16px",
  },
  toggleButton: {
    display: "flex",
    borderRadius: 4,
    overflow: "hidden",
    border: "1px solid #ccc",
  },
  langButton: {
    padding: "4px 12px",
    fontSize: 13,
    fontWeight: 600,
    border: "none",
    cursor: "pointer",
    transition: "background-color 0.2s, color 0.2s",
    outline: "none",
    minWidth: 36,
  },
  active: {
    backgroundColor: "#fff",
    color: process.env.REACT_APP_MAIN_SCHOOL_COLOR || "#333",
  },
  inactive: {
    backgroundColor: process.env.REACT_APP_MAIN_SCHOOL_COLOR || "#333",
    color: "#fff",
    "&:hover": {
      opacity: 0.9,
    },
  },
}));

function LanguageToggle() {
  const classes = useStyles();
  const { language, setLanguage, isMultilingualEnabled } = useLanguage();

  if (!isMultilingualEnabled) return null;

  return (
    <div className={classes.toggleContainer}>
      <div className={classes.toggleButton}>
        <button
          className={`${classes.langButton} ${
            language === LANG.EN ? classes.active : classes.inactive
          }`}
          onClick={() => setLanguage(LANG.EN)}
          aria-label="English"
        >
          EN
        </button>
        <button
          className={`${classes.langButton} ${
            language === LANG.JA ? classes.active : classes.inactive
          }`}
          onClick={() => setLanguage(LANG.JA)}
          aria-label="日本語"
        >
          JP
        </button>
      </div>
    </div>
  );
}

export default React.memo(LanguageToggle);
